import { gql } from "@apollo/client"

export const MUTATION = gql`
  mutation UpdateOfferPurchase($input: OfferPurchaseInput!) {
    updateOfferPurchase(input: $input)
  }
`
